import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineStepDataFragment as PipelineStepDataFragmentType} from './__generated/PipelineStepDataFragment';

export const PIPELINE_STEP_DATA_FRAGMENT = gql`
  fragment PipelineStepDataFragment on PipelineStepDataDomainNode {
    id
    name
    rawDatas {
      ... on DataFrameDomainNode {
        id
        name
        columns {
          systemName
          displayName
          type
        }
      }
      ... on ChartNode {
        id
        name
        library
        # Omitted for lazy loading (fetched via GET_CHART_QUERY):
        # libraryConfig, libraryVersion, rasterDownloadUrl, rasterExternalFileId
      }
      ... on ScratchFileNode {
        id
        name
        filename
        externalFileId
        # Omitted for lazy loading (fetched via GET_SCRATCH_FILE_QUERY):
        # downloadUrl, mimeType
      }
      ... on ScratchPlateNode {
        id
        name
      }
    }
  }
`;

export const PipelineStepDataFragment: FragmentWrapper<PipelineStepDataFragmentType> = {
  fragment: PIPELINE_STEP_DATA_FRAGMENT,
  fragmentName: 'PipelineStepDataFragment',
};
